import { forwardRef } from 'react';
import { Flex as ThemeFlex, FlexProps } from 'theme-ui';

export type FlexDirections = 'row'|'column'|'row-reverse'|'column-reverse';
export type ItemAlignments = 'center'|'start'|'end'|'flex-start'|'flex-end'|'baseline'|
  'first baseline'|'last baseline'|'safe center'|'unsafe center'|'inherit'|'initial'|
  'revert'|'revert-layer'|'unset';
export type Justifications = 'center'|'start'|'end'|'flex-start'|'flex-end'|'left'|'right'|'normal'|
  'space-between'|'space-around'|'space-evenly'|'stretch'|
  'safe center'|'unsafe center'|'inherit'|'initial'|'revert'|'revert-layer'|'unset';
export type ContentAlignments = 'center'|'start'|'end'|'flex-start'|'flex-end'|'normal'|
  'baseline'|'first baseline'|'last baseline'|'space-between'|'space-around'|'space-evenly'|'stretch'|
  'safe center'|'unsafe center'|'inherit'|'initial'|'revert'|'revert-layer'|'unset';

export interface CustomFlexProps extends FlexProps {
  direction?: FlexDirections | Array<FlexDirections>;
  alignItems?: ItemAlignments | Array<ItemAlignments>;
  justifyContent?: Justifications | Array<Justifications>;
  alignContent?: ContentAlignments | Array<ContentAlignments>;
  width?: string | number;
  inline?: boolean
  gap?: string | number;
};

const Flex = forwardRef<HTMLElement, CustomFlexProps>(({ direction, alignItems, justifyContent, alignContent, width, inline = false, gap, sx, ...props }: CustomFlexProps, ref) => {
    return (
      <ThemeFlex
        ref={ref}
        {...props}
        sx={{
          display: inline ? 'inline-flex' : 'flex',
          flexDirection: direction,
          alignItems,
          justifyContent,
          alignContent,
          width,
          gap,
          ...sx,
        }}
      />
    );
});

export default Flex;
